/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init';
/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/guide/browser-support
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags
 * because those flags need to be set before `zone.js` being loaded, and webpack
 * will put import in the top of bundle, so user need to create a separate file
 * in this directory (for example: zone-flags.ts), and put the following flags
 * into that file, and then add the following code before importing zone.js.
 * import './zone-flags.ts';
 *
 * The flags allowed in zone-flags.ts are listed here.
 *
 * The following flags will work for all browsers.
 *
 * (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
 * (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
 * (window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames
 *
 *  in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
 *  with the following flag, it will bypass `zone.js` patch for IE/Edge
 *
 *  (window as any).__Zone_enable_cross_context_check = true;
 *
 */

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js';  // Included with Angular CLI.


/***************************************************************************************************
 * APPLICATION IMPORTS
 */
import {isNullOrUndefined} from '@app/shared/helpers/utility-functions';
declare global {
  interface Object {
    deepClone(object: any): any;
  }
}
Object.defineProperty(Object.prototype, 'deepClone', {
  value(objectToClone) {
    // Turns any date strings into Date objects for the passed in object
    // tslint:disable-next-line:only-arrow-functions
    const convertDateStrings = function(objectToSearch: any): any {
      // Date strings will be in the following format (result of calling JSON.stringify() on a Date object): "2018-11-07T18:02:59.790Z"
      const isDateString = (stringToSearch: string): boolean => {
        if (typeof(stringToSearch) !== 'string') { return false; }
        if (stringToSearch.length === 24 && (stringToSearch.charAt(23) === 'z' || stringToSearch.charAt(23) === 'Z') &&
          !isNaN(Number(stringToSearch.charAt(22)))) { return true; }
      };
      // tslint:disable-next-line:forin
      for (const key in objectToSearch) {
        const value = objectToSearch[key];
        if (isDateString(value)) {
          objectToSearch[key] = new Date(value);
        }
        if (typeof(objectToSearch[key]) === 'object' && objectToSearch[key] !== null) {
          let innerObject = objectToSearch[key];
          innerObject = convertDateStrings(innerObject);
        }
      }
      return objectToSearch;
    };
    if (!isNullOrUndefined(objectToClone)) {
      let clonedObject = JSON.parse(JSON.stringify(objectToClone));
      clonedObject = convertDateStrings(clonedObject);
      return clonedObject;
    }
    return null;
  },
  enumerable: false,
});
